"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHashesArray = void 0;
const react_router_dom_1 = require("react-router-dom");
const useHash = () => {
    const { replace } = (0, react_router_dom_1.useHistory)();
    const { hash: urlHash, search, pathname } = (0, react_router_dom_1.useLocation)();
    const urlHashes = (0, exports.getHashesArray)(urlHash);
    const hasHash = (...hashes) => hashes === null || hashes === void 0 ? void 0 : hashes.every(h => urlHashes === null || urlHashes === void 0 ? void 0 : urlHashes.includes(h));
    const addHash = (...hashes) => __awaiter(void 0, void 0, void 0, function* () {
        const canAddHashes = hashes === null || hashes === void 0 ? void 0 : hashes.filter(h => !(urlHashes === null || urlHashes === void 0 ? void 0 : urlHashes.includes(h)));
        if ((canAddHashes === null || canAddHashes === void 0 ? void 0 : canAddHashes.length) === 0)
            return;
        replace(pathname + search + urlHash + '#' + (canAddHashes === null || canAddHashes === void 0 ? void 0 : canAddHashes.join('#')));
    });
    const removeHash = (...hashes) => __awaiter(void 0, void 0, void 0, function* () {
        const canRemoveHashes = hashes === null || hashes === void 0 ? void 0 : hashes.filter(h => urlHashes === null || urlHashes === void 0 ? void 0 : urlHashes.includes(h));
        if ((canRemoveHashes === null || canRemoveHashes === void 0 ? void 0 : canRemoveHashes.length) === 0)
            return;
        let removedHashes = urlHash;
        canRemoveHashes === null || canRemoveHashes === void 0 ? void 0 : canRemoveHashes.forEach(crm => (removedHashes = removedHashes === null || removedHashes === void 0 ? void 0 : removedHashes.replace(`#${crm}`, '')));
        replace(pathname + search + removedHashes);
    });
    const modifyHash = (add = [], remove = []) => {
        let modifiedHash = urlHash;
        remove === null || remove === void 0 ? void 0 : remove.forEach(rh => hasHash(rh) && (modifiedHash = modifiedHash === null || modifiedHash === void 0 ? void 0 : modifiedHash.replace(`#${rh}`, '')));
        add === null || add === void 0 ? void 0 : add.forEach(ah => !hasHash(ah) && (modifiedHash = `#${ah}` + modifiedHash));
        replace(pathname + search + modifiedHash);
    };
    return {
        hasHash,
        addHash,
        removeHash,
        modifyHash,
        hashes: urlHashes,
    };
};
const getHashesArray = (hash) => { var _a; return ((_a = hash === null || hash === void 0 ? void 0 : hash.split('#')) === null || _a === void 0 ? void 0 : _a.slice(1)) || []; };
exports.getHashesArray = getHashesArray;
exports.default = useHash;
